import React, { useState, useEffect } from "react";
import moment from "moment";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import api from "../../../services/api";
import { IAM_API_BASE_URL_2, INVENTORY_API_BASE_URL_2 } from "../../../services/TapApiUrls";
import Loader from "../../../components/ui/Loader/Loader";
import DateService from "../../../services/DateService";
import { DisplayListPagination } from "../../../components/TapUi";
import TapHelper from "../../../services/TapHelper";

const PoEventListModal = ({ isOpen, selectedDate, onClose }) => {
    const [loading, setLoading] = useState(false);
    const [events, setEvents] = useState([]);
    const [meta, setMeta] = useState({});
    const accessToken = useSelector(state => state.auth.access_token);

    useEffect(() => {
        if (isOpen && selectedDate) {
            fetchPoDetails();
        }
    }, [isOpen, selectedDate]);

    const fetchPoDetails = async (page = 1) => {
        setLoading(true);
        try {
            const headers = { 'Authorization': 'Bearer ' + accessToken };
            const params = {
                search_date_from: selectedDate,
                search_date_to: selectedDate,
                search_status_levels: ["4", "5"],
                per_page: 20,
                page: page

            };

            const response = await api.server2Api.get(`${INVENTORY_API_BASE_URL_2}/purchase_order`, {
                params, headers
            });

            const responseData = response.data || {};
            const listPayload = responseData.list ? responseData.list : responseData;
            const listingMeta = listPayload && listPayload.meta ? listPayload.meta : (listPayload && listPayload.current_page ? listPayload : null);
            const warehouses = responseData.warehouses && responseData.warehouses.length > 0 ? responseData.warehouses : [];
            const statusList = responseData.status && responseData.status.length > 0 ? responseData.status : [];
            const listingRows = listPayload && listPayload.data && listPayload.data.length > 0 ? listPayload.data : [];

            const normalizedEvents = listingRows.map((row) => {
                const warehouseData = row.warehouse ? row.warehouse : warehouses.find((warehouse) => Number(warehouse.id) === Number(row.warehouse_id));
                const statusData = row.status_data ? row.status_data : statusList.find((status) => Number(status.id) === Number(row.status));

                return {
                    ...row,
                    warehouse: warehouseData || null,
                    status_data: statusData || null,
                    transaction_date_display: row.transaction_date_display ? row.transaction_date_display : (row.transaction_date ? DateService.dateTimeFormat(row.transaction_date, 'DD-MMM-YYYY') : '-'),
                    expected_delivery_date_display: row.expected_delivery_date_display ? row.expected_delivery_date_display : (row.expected_delivery_date ? DateService.dateTimeFormat(row.expected_delivery_date, 'DD-MMM-YYYY') : '-')
                };
            });

            setMeta(
                TapHelper.pick(listingMeta, [
                    'from',
                    'to',
                    'total',
                    'last_page',
                    'per_page',
                    'current_page'
                ])
            );

            setEvents(normalizedEvents);
        } catch (error) {
            toast.error('Failed to load PO details');
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal fade show d-block">
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">
                            PO Events for {DateService.dateFormat(selectedDate, 'DD MMM YYYY')}
                        </h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div style={{ maxHeight: "500px", overflowY: "auto" }}>
                        <div className="modal-body">
                            {loading ? (
                                <div className="text-center py-3"><Loader /></div>
                            ) : (
                                <table className="table table-bordered table-sm align-middle bg-white mt-2">
                                    <thead className="align-middle table-secondary">
                                        <tr>
                                            <th scope="col" style={{ width: "5%" }} className="text-center">S.No</th>
                                            <th scope="col" style={{ width: "17%" }}>PO Number</th>
                                            <th scope="col" style={{ width: "17%" }} className="text-center">PO Date</th>
                                            <th scope="col" style={{ width: "25%" }}>Warehouse</th>
                                            <th scope="col" style={{ width: "17%" }} className="text-center">Due Date</th>
                                            <th scope="col" style={{ width: "17%" }} className="text-center">Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {events.length > 0 ? (
                                            events.map((event, index) => (
                                                <tr key={event.id || index}>
                                                    <td className='text-center'>
                                                        {((meta.current_page - 1) * meta.per_page) + index + 1}
                                                    </td>
                                                    <td> {event?.transaction_id ? event?.transaction_id : '-'}</td>
                                                    <td className='text-center'> {event?.transaction_date_display ? event?.transaction_date_display : '-'} </td>
                                                    <td> {event.warehouse?.name || '-'}</td>
                                                    <td className='text-center'>{event.expected_delivery_date_display ? event.expected_delivery_date_display : '-'}
                                                    </td>
                                                    <td  className="text-center"> {event?.status_data?.name}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td className="text-center" colSpan={10}>No Record Found</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            )}
                            {events.length > 0 && (
                                <DisplayListPagination
                                    meta={meta}
                                    onPageChange={(e) => fetchPoDetails(e.selected + 1)}
                                />
                            )}
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>Close</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PoEventListModal;